import { makeAutoObservable, runInAction } from 'mobx';
import { apiClient } from '../api/apiclient';
import { academyStore } from './AcademyStore';
export class PlayerDashboardStore {
    constructor() {
        this.players = [];
        this.selectedPlayer = null;
        this.selectedTimePeriod = 12; // Default to 12 weeks
        this.selectedBatchId = ''; // Empty string means "all batches"
        this.ratingMode = 'latest'; // Rating display mode
        this.loading = false;
        this.error = null;
        this.isDetailDialogOpen = false;
        this.openPlayerDetail = async (playerId) => {
            if (!academyStore.currentAcademy) {
                throw new Error('No academy selected');
            }
            this.isDetailDialogOpen = true;
            await this.fetchPlayerDetails(academyStore.currentAcademy.id, playerId, this.selectedTimePeriod);
        };
        this.closePlayerDetail = () => {
            this.isDetailDialogOpen = false;
            this.selectedPlayer = null;
        };
        makeAutoObservable(this);
    }
    // Computed property to get filtered players based on selected batch
    get filteredPlayers() {
        if (!this.selectedBatchId) {
            return this.players; // Return all players if no batch is selected
        }
        return this.players.filter(player => player.batchId === this.selectedBatchId);
    }
    // Actions
    async fetchPlayersDashboard(academyId, weeks) {
        const weeksToUse = weeks !== undefined ? weeks : this.selectedTimePeriod;
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.getPlayersDashboard(academyId, weeksToUse);
            if (response.success) {
                runInAction(() => {
                    this.players = response.data;
                    this.selectedTimePeriod = weeksToUse;
                    this.loading = false;
                });
            }
            else {
                runInAction(() => {
                    this.error = response.message;
                    this.loading = false;
                });
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to fetch players dashboard';
                this.loading = false;
            });
        }
    }
    async fetchPlayerDetails(academyId, playerId, weeks) {
        const weeksToUse = weeks !== undefined ? weeks : this.selectedTimePeriod;
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.getPlayerDetails(academyId, playerId, weeksToUse);
            if (response.success) {
                runInAction(() => {
                    this.selectedPlayer = response.data;
                    this.loading = false;
                });
            }
            else {
                runInAction(() => {
                    this.error = response.message;
                    this.loading = false;
                });
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to fetch player details';
                this.loading = false;
            });
        }
    }
    setTimePeriod(weeks) {
        if (![4, 8, 12].includes(weeks)) {
            throw new Error('Weeks must be 4, 8, or 12');
        }
        this.selectedTimePeriod = weeks;
        // Refetch dashboard data with new time period
        if (academyStore.currentAcademy) {
            this.fetchPlayersDashboard(academyStore.currentAcademy.id, weeks);
        }
    }
    setSelectedBatch(batchId) {
        this.selectedBatchId = batchId;
    }
    setRatingMode(mode) {
        this.ratingMode = mode;
    }
    // Update player details when time period changes in dialog
    async updatePlayerDetailsTimePeriod(weeks) {
        if (!academyStore.currentAcademy || !this.selectedPlayer) {
            return;
        }
        await this.fetchPlayerDetails(academyStore.currentAcademy.id, this.selectedPlayer.playerId, weeks);
    }
}
export const playerDashboardStore = new PlayerDashboardStore();
